import { useTranslation, Trans } from '@exam-room/translations';

import { Button, Modal, type ModalProps } from '../../../../../components';

type ExamPreviewRestartModalProps = Omit<ModalProps, 'children'> & {
  onAccept: () => void;
  onCancel: () => void;
};

export default function ExamPreviewRestartModal({
  open,
  onAccept,
  onCancel,
}: Readonly<ExamPreviewRestartModalProps>) {
  const { t } = useTranslation();

  return (
    <Modal open={open} className='grid max-w-xl gap-8'>
      <h3>{t('examPreviewRestartModal.title')}</h3>
      <p className='font-normal'>
        <Trans
          i18nKey='examPreviewRestartModal.details'
          components={{
            strong: <strong />,
            br: <br />,
          }}
        />
      </p>

      <div className='flex justify-end gap-3'>
        <Button className='w-[121px] text-black' onClick={onCancel} variant='outlined'>
          {t('examPreviewRestartModal.button.canceled')}
        </Button>
        <Button className='w-[121px] text-black' onClick={onAccept}>
          {t('examPreviewRestartModal.button.startNewExam')}
        </Button>
      </div>
    </Modal>
  );
}
